import React from 'react';

import WIDGETS_DATA from './../data/widgets/widgets.json';

const useWidgets = (): ReturnUseWidgets => {
    const [selectedWidgets, setSelectedWidgets] = React.useState<Record<string, any>[]>();

    const handleSelectWidget = (widgetKey: string) => {
        setSelectedWidgets((prevSelectedWidgets: Record<string, any>[]) => {
            return prevSelectedWidgets.map((widget: Record<string, any>) => {
                if (widget.key === widgetKey) {
                    return {
                        ...widget,
                        isSelected: !widget.isSelected,
                    };
                }
                return widget;
            });
        });
    };

    React.useEffect(() => {
        const availableWidgets = Object.entries(WIDGETS_DATA.reportWidgets).map(([key, value]) => {
            return {
                key,
                ...value,
                isSelected: true,
            };
        });

        setSelectedWidgets(availableWidgets);
    }, []);

    return {
        selectedWidgets,
        handleSelectWidget,
    };
};

interface ReturnUseWidgets {
    selectedWidgets: Record<string, any>[];
    handleSelectWidget: (widgetKey: string) => void;
}

export default useWidgets;
